import React from "react";
import { Box, Switch, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const SwitchSizes = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch Sizes ( Medium and Small)
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          By Default size of Switch is set to <strong>medium</strong>.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Primary switches sizes. Medium and small"}
          language={"js"}
          value={
            '           <Switch defaultChecked color={"primary"} />\n' +
            "          <Switch\n" +
            "            defaultChecked\n" +
            '            color={"primary"}\n' +
            '            size={"small"}\n' +
            "          />"
          }
        >
          <Switch defaultChecked color={"primary"} />
          <Switch
            defaultChecked
            color={"primary"}
            size={"small"}
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default SwitchSizes;
